import type { AcademyConfirmedBy } from '../../../pages/academy/Academy/AcademyService';

export type AcademySkillProgressState = 'complete' | 'partially_complete' | 'not_complete';

export function getConfirmationLabel(confirmedBy: AcademyConfirmedBy): string {
  return isConfirmed(confirmedBy) ? 'complete' : 'not complete';
}

export function getSkillProgressLabel(
  learnConfirmedBy: AcademyConfirmedBy,
  applyConfirmedBy: AcademyConfirmedBy,
  learnRequired = true,
  applyRequired = true,
): string {
  const progressState = getSkillProgressState(
    learnConfirmedBy,
    applyConfirmedBy,
    learnRequired,
    applyRequired,
  );

  if (progressState === 'complete') {
    return 'complete';
  }

  if (progressState === 'partially_complete') {
    return 'partially complete';
  }

  return 'not complete';
}

export function getSkillProgressState(
  learnConfirmedBy: AcademyConfirmedBy,
  applyConfirmedBy: AcademyConfirmedBy,
  learnRequired = true,
  applyRequired = true,
): AcademySkillProgressState {
  if (
    isRequiredProgressComplete(
      learnConfirmedBy,
      applyConfirmedBy,
      learnRequired,
      applyRequired,
    )
  ) {
    return 'complete';
  }

  if (isConfirmed(learnConfirmedBy) || isConfirmed(applyConfirmedBy)) {
    return 'partially_complete';
  }

  return 'not_complete';
}

export function isConfirmed(confirmedBy: AcademyConfirmedBy): boolean {
  return confirmedBy !== 'none';
}

export function isRequiredProgressComplete(
  learnConfirmedBy: AcademyConfirmedBy,
  applyConfirmedBy: AcademyConfirmedBy,
  learnRequired: boolean,
  applyRequired: boolean,
): boolean {
  if (!learnRequired && !applyRequired) {
    return isConfirmed(learnConfirmedBy) || isConfirmed(applyConfirmedBy);
  }

  return (
    (!learnRequired || isConfirmed(learnConfirmedBy)) &&
    (!applyRequired || isConfirmed(applyConfirmedBy))
  );
}
